import { render, staticRenderFns } from "./SharedAnimatedIconArrow.vue?vue&type=template&id=0535cb30&scoped=true&"
import script from "./SharedAnimatedIconArrow.vue?vue&type=script&lang=js&"
export * from "./SharedAnimatedIconArrow.vue?vue&type=script&lang=js&"
import style0 from "./SharedAnimatedIconArrow.vue?vue&type=style&index=0&id=0535cb30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535cb30",
  null
  
)

export default component.exports